<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :table-options="tableOptions"
    :search-items="searchItems"
    :form-items="formItems"
  />
</template>
<script>
export default {
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'pharmacy/pharmacy/cooperation/cooperationdecoctingfee',
      // Web路径
      webPath: 'pharmacy/pharmacy/cooperation/cooperationdecoctingfee',
      tableOptions: ['details', 'filter'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "cooperationCode",
              span: 6,
              name: "签约信息编码",
              type: "popup",
              config: {
                url: "pharmacy/pharmacy/cooperation/cooperation",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                minLength: 0,
                maxLength: 20,
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("cooperationName", row.name)
                  this.$refs.commonPage.updateFormData("cooperationId", row.id)
                  this.$refs.commonPage.updateFormData("pharmacyCode", row.pharmacyCode)
                  this.$refs.commonPage.updateFormData("pharmacyName", row.pharmacyName)
                  this.$refs.commonPage.updateFormData("pharmacyId", row.pharmacyId)
                  this.$refs.commonPage.updateFormData("storeCode", row.storeCode)
                  this.$refs.commonPage.updateFormData("storeName", row.storeName)
                  this.$refs.commonPage.updateFormData("storeId", row.storeId)
                }
              }
            },
            // {
            //   code: "cooperationName",
            //   name: "签约信息名称",
            //   type: "text",
            //   span: 6,
            //   config: {
            //     edit: false,
            //     disabled: true
            //   }
            // },
            {
              code: "serveFeeSign",
              name: "服务型标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                options: [{ key: "01", value: "代煎" }, { key: "11", value: "制粒" }, {
                  key: "21",
                  value: "细粉打粉"
                }, { key: "22", value: "粗粉打粉" }, { key: "31", value: "水丸制丸" }, {
                  key: "32",
                  value: "蜜丸制丸"
                }, { key: "33", value: "大蜜丸制丸" }, { key: "34", value: "浓缩丸制丸" }, {
                  key: "35",
                  value: "水蜜丸制丸"
                }, { key: "41", value: "制瓶装膏" }, { key: "42", value: "制袋装膏" }, {
                  key: "43",
                  value: "制块装膏"
                }
                ]
              }
            }, {
              code: "feeTypeSign",
              name: "计费方式标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                options: [
                  { key: "1", value: "按方计费" },
                  { key: "2", value: "按剂计费" },
                  { key: "3", value: "按重计费" }
                ]
              }
            }, {
              code: "servePrice",
              name: "服务单价",
              span: 6,
              type: "number",
              search: true,
              config: {
                edit: false
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "cooperationCode",
          name: "签约信息编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        // {
        //   code: "cooperationName",
        //   name: "签约信息名称",
        //   type: "text",
        //   span: 6,
        //   config: {
        //     edit: false,
        //     disabled: true
        //   }
        // },
        {
          code: "serveFeeSign",
          name: "服务型标识",
          span: 6,
          type: "select",
          search: true,
          config: {
            edit: false,
            defaultValue: '01',
            options: [{ key: "01", value: "代煎" }, { key: "11", value: "制粒" }, {
              key: "21",
              value: "细粉打粉"
            }, { key: "22", value: "粗粉打粉" }, { key: "31", value: "水丸制丸" }, {
              key: "32",
              value: "蜜丸制丸"
            }, { key: "33", value: "大蜜丸制丸" }, { key: "34", value: "浓缩丸制丸" }, {
              key: "35",
              value: "水蜜丸制丸"
            }, { key: "41", value: "制瓶装膏" }, { key: "42", value: "制袋装膏" }, {
              key: "43",
              value: "制块装膏"
            }
            ]
          }
        }, {
          code: "feeTypeSign",
          name: "计费方式标识",
          span: 6,
          type: "select",
          search: true,
          config: {
            edit: false,
            defaultValue: '1',
            options: [
              { key: "1", value: "按方计费" },
              { key: "2", value: "按剂计费" },
              { key: "3", value: "按重计费" }
            ]
          }
        }, {
          code: "servePrice",
          name: "服务单价",
          span: 6,
          type: "number",
          search: true,
          config: {
            edit: false
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "cooperationCode",
              span: 6,
              name: "签约信息编码",
              type: "popup",
              config: {
                url: "pharmacy/pharmacy/cooperation/cooperation",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'pharmacyName', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("cooperationName", row.pharmacyName)
                  this.$refs.commonPage.updateFormData("cooperationId", row.id)
                  this.$refs.commonPage.updateFormData("pharmacyCode", row.pharmacyCode)
                  this.$refs.commonPage.updateFormData("pharmacyName", row.pharmacyName)
                  this.$refs.commonPage.updateFormData("pharmacyId", row.pharmacyId)
                  this.$refs.commonPage.updateFormData("storeCode", row.storeCode)
                  this.$refs.commonPage.updateFormData("storeName", row.storeName)
                  this.$refs.commonPage.updateFormData("storeId", row.storeId)
                }
              }
            },
            // {
            //   code: "cooperationName",
            //   name: "签约信息名称",
            //   type: "text",
            //   span: 6,
            //   config: {
            //     edit: false,
            //     disabled: true
            //   }
            // },
            {
              code: "serveFeeSign",
              name: "服务型标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                defaultValue: '01',
                options: [{ key: "01", value: "代煎" }, { key: "11", value: "制粒" }, {
                  key: "21",
                  value: "细粉打粉"
                }, { key: "22", value: "粗粉打粉" }, { key: "31", value: "水丸制丸" }, {
                  key: "32",
                  value: "蜜丸制丸"
                }, { key: "33", value: "大蜜丸制丸" }, { key: "34", value: "浓缩丸制丸" }, {
                  key: "35",
                  value: "水蜜丸制丸"
                }, { key: "41", value: "制瓶装膏" }, { key: "42", value: "制袋装膏" }, {
                  key: "43",
                  value: "制块装膏"
                }
                ]
              }
            }, {
              code: "feeTypeSign",
              name: "计费方式标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                defaultValue: '1',
                options: [
                  { key: "1", value: "按方计费" },
                  { key: "2", value: "按剂计费" },
                  { key: "3", value: "按重计费" }
                ]
              }
            }, {
              code: "servePrice",
              name: "服务单价",
              span: 6,
              type: "number",
              search: true,
              config: {
                edit: false
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
